<script setup>
import LayoutNew from "@/Layouts/LayoutNew.vue";
import { Head } from "@inertiajs/inertia-vue3";
import { ref, onMounted, computed } from "vue";
import axios from "axios";
import { __ } from "@/app";

const stats = ref([]);
const isLoading = ref(true);

// Add props definition for user
const props = defineProps({
    auth: Object
});

// Add computed property to check premium status
const isPremium = computed(() => {
    if (!props.auth?.user?.premium_expires_at) return false;
    return new Date(props.auth.user.premium_expires_at) > new Date();
});

onMounted(async () => {
    try {
        const response = await axios.get(route('statistics.stats'));
        stats.value = response.data.stats;
    } catch (error) {
        console.error('Failed to load stats:', error);
    } finally {
        isLoading.value = false;
    }
});
</script>

<template>
    <LayoutNew layout="vertical">
        <Head :title="__('Statystyka')" />
        
        <div class="container my-5">
            <h2 class="mb-4">
                {{ __('Statysyka') }}
                <span v-if="isPremium" class="badge bg-warning ms-2">Premium <i class="bi bi-trophy-fill"></i></span>                
            </h2>
            
            <div v-if="isLoading" class="text-center">
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>

            <div v-else class="row">
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>{{ __('Reguła') }}</th>
                                    <th>{{ __('Poprawne odpowiedzi') }}</th>
                                    <th>{{ __('Błędne odpowiedzi') }}</th>
                                    <th>{{ __('Skuteczność') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="stat in stats" :key="stat.rule_id">                                    
                                    <td v-html="stat.rule_title"></td>
                                    <td class="text-success">{{ stat.correct }}</td>
                                    <td class="text-danger">{{ stat.incorrect }}</td>
                                    <td>
                                        <div class="progress" style="height: 20px;">
                                            <div class="progress-bar bg-success" 
                                                 :style="{ width: stat.success_rate + '%' }" 
                                                 role="progressbar">
                                                {{ stat.success_rate }}%
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </LayoutNew>
</template> 